import { render } from "./ProjectView.vue?vue&type=template&id=3006bf42&ts=true"
import script from "./ProjectView.vue?vue&type=script&lang=ts"
export * from "./ProjectView.vue?vue&type=script&lang=ts"

import "./ProjectView.vue?vue&type=style&index=0&id=3006bf42&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__